var BackupStatus;
(function (BackupStatus) {
    BackupStatus[BackupStatus["REQUESTED"] = 0] = "REQUESTED";
    BackupStatus[BackupStatus["RUNNING"] = 1] = "RUNNING";
    BackupStatus[BackupStatus["FAILED"] = 2] = "FAILED";
    BackupStatus[BackupStatus["READY"] = 3] = "READY";
    BackupStatus[BackupStatus["DOWNLOADED"] = 4] = "DOWNLOADED";
})(BackupStatus || (BackupStatus = {}));
export default BackupStatus;
//# sourceMappingURL=BackupStatus.js.map